import {
  rfPainRelief,
  thinkFactorBottle,
  rfZenFactor,
  rfGoFactor,
  rfZFactor,
  antioxidantsBottle,
  fullSpectrumBottle,
  immuneFactorsBottle,
  nacBottle,
  berberineBottle,
  vitaminBComplexBottle,
  redYeastRiceBottle,
  vesselProtectionBottle,
  vitaminD3K22000Bottle,
  vitaminD3K25000Bottle,
  brainAndMentalSupport,
  jointAndPainSupport,
  energyAndVitalitySupport,
  heartAndCirculatorySupport,
  immuneAndSystemSupport,
  sleepAndRelaxationSupport,
} from '../../src/images';
import { productsKeyConstants } from '../../config';

export const sections = [
  {
    key: 'energy',
    title: 'Joint & Pain Support',
    subtitle: 'The Power to Transform Pain',
    leftImage: jointAndPainSupport,
    products: [
      {
        productKey: productsKeyConstants.RF_RELIEF_FACTOR_QS_NEC,
        title: 'Relief Factor',
        description: 'Support for temporary relief of minor aches and pains.',
        image: rfPainRelief,
        url: '/products/relief-factor',
      },
      {
        productKey: productsKeyConstants.RF_FULL_SPECTRUM_E,
        title: 'Full Spectrum E',
        description:
          'Powerful antioxidants that protect joints by reducing oxidative stress.',
        image: fullSpectrumBottle,
        url: '/products/full-spectrum-e',
      },
      {
        productKey: productsKeyConstants.DE_ANTIOXIDANTS,
        title: 'Antioxidants with Vitamin C & Bioflavonoids',
        description:
          'Bioflavonoids and Vitamin C support collagen production and help joint tissue health.',
        image: antioxidantsBottle,
        url: '/products/antioxidants',
      },
      {
        productKey: productsKeyConstants.RF_N_ACETYL_CYSTEINE,
        title: 'NAC',
        description:
          'Restores glutathione, reducing inflammatory oxidative stress in joint tissues.',
        image: nacBottle,
        url: '/products/nac',
      },
    ],
  },
  {
    key: 'energy',
    title: 'Brain & Mental Performance',
    subtitle: 'The Power to Transform Cognition and Mental Energy',
    leftImage: brainAndMentalSupport,
    products: [
      {
        productKey: productsKeyConstants.RF_THINK_FACTOR,
        title: 'Think Factor',
        description:
          'Boost your brainpower with better memory, sharper focus, and faster thinking.',
        image: thinkFactorBottle,
        url: '/products/think-factor',
      },
      {
        productKey: productsKeyConstants.RF_GO_FACTOR,
        title: 'Go Factor',
        description: 'Boosts alertness and mental energy.',
        image: rfGoFactor,
        url: '/products/go-factor',
      },
      {
        productKey: productsKeyConstants.RF_ZEN_FACTOR,
        title: 'Zen Factor',
        description: 'Reduces stress and brain fog leading to improved focus.',
        image: rfZenFactor,
        url: '/products/zen-factor',
      },
      {
        productKey: productsKeyConstants.RF_FULL_SPECTRUM_E,
        title: 'Full Spectrum E',
        description: 'Antioxidants protect brain cells from oxidative damage.',
        image: fullSpectrumBottle,
        url: '/products/full-spectrum-e',
      },
      {
        productKey: productsKeyConstants.RF_VITAMIN_B_COMPLEX,
        title: 'Vitamin B Complex',
        description: 'Supports neurotransmitter synthesis and clear thinking.',
        image: vitaminBComplexBottle,
        url: '/products/vitamin-b-complex',
      },
    ],
  },
  {
    key: 'energy',
    title: 'Immune System Support',
    subtitle: 'The Power to Transform Your Immune System',
    leftImage: immuneAndSystemSupport,
    products: [
      {
        productKey: productsKeyConstants.RF_IMMUNE_FACTOR,
        title: 'Immune Factors',
        description: 'Strengthens your overall immune response.',
        image: immuneFactorsBottle,
        url: '/products/immune-factors',
      },
      {
        productKey: productsKeyConstants.RF_BERBERINE,
        title: 'Berberine',
        description:
          'Bolsters your immune health from a digestive perspective.',
        image: berberineBottle,
        url: '/products/berberine',
      },
      {
        productKey: productsKeyConstants.DE_ANTIOXIDANTS,
        title: 'Antioxidants with Vitamin C & Bioflavonoids',
        description:
          'Vitamin C and bioflavonoids support immune cell function and antioxidant protection.',
        image: antioxidantsBottle,
        url: '/products/antioxidants',
      },
      {
        productKey: productsKeyConstants.RF_N_ACETYL_CYSTEINE,
        title: 'NAC',
        description:
          'Enhances antioxidant glutathione, essential for immune function.',
        image: nacBottle,
        url: '/products/nac',
      },
      {
        productKey: productsKeyConstants.RF_VITAMIN_D_K2,
        title: 'Vitamin D3 and K-2 (2,000/5,000 IU)',
        description:
          'Supports immune health and nutrient absorption and efficacy.',
        image: vitaminD3K22000Bottle,
        url: '/products/vitamin-d-k',
      },
    ],
  },
  {
    key: 'energy',
    title: 'Energy & Vitality',
    subtitle: 'The Power to Transform Cognition and Energy',
    leftImage: energyAndVitalitySupport,
    products: [
      {
        productKey: productsKeyConstants.RF_THINK_FACTOR,
        title: 'Think Factor',
        description:
          'Supports cognitive energy and stamina throughout the day, enhancing mental vitality.',
        image: thinkFactorBottle,
        url: '/products/think-factor',
      },
      {
        productKey: productsKeyConstants.RF_GO_FACTOR,
        title: 'Go Factor',
        description:
          'Provides natural energy boost, vitamins, and amino acids for increased energy and function.',
        image: rfGoFactor,
        url: '/products/go-factor',
      },
      {
        productKey: productsKeyConstants.RF_FULL_SPECTRUM_E,
        title: 'Full Spectrum E',
        description:
          'Supports efficient energy, metabolism, and cellular health.',
        image: fullSpectrumBottle,
        url: '/products/full-spectrum-e',
      },
      {
        productKey: productsKeyConstants.RF_BERBERINE,
        title: 'Berberine',
        description:
          'Enhances metabolic efficiency and helps maintain steady energy levels by balancing blood sugar.',
        image: berberineBottle,
        url: '/products/berberine',
      },
      {
        productKey: productsKeyConstants.RF_VITAMIN_B_COMPLEX,
        title: 'Vitamin B Complex',
        description:
          'Converts food into cellular energy which is essential for maintaining daily vitality.',
        image: vitaminBComplexBottle,
        url: '/products/vitamin-b-complex',
      },
    ],
  },
  {
    key: 'energy',
    title: 'Sleep & Relaxation',
    subtitle: 'The Power to Transform Anxiety & Sleep',
    leftImage: sleepAndRelaxationSupport,
    products: [
      {
        productKey: productsKeyConstants.RF_ZEN_FACTOR,
        title: 'Zen Factor',
        description:
          'Promotes calmness while reducing cortisol and easing everyday stress.',
        image: rfZenFactor,
        url: '/products/zen-factor',
      },
      {
        productKey: productsKeyConstants.RF_Z_FACTOR,
        title: 'Z Factor',
        description: 'Support restful and restorative sleep.',
        image: rfZFactor,
        url: '/products/z-factor',
      },
      {
        productKey: productsKeyConstants.RF_VITAMIN_B_COMPLEX,
        title: 'Vitamin B Complex',
        description: 'Helps calm your body and regulate mood.',
        image: vitaminBComplexBottle,
        url: '/products/vitamin-b-complex',
      },
      {
        productKey: productsKeyConstants.RF_N_ACETYL_CYSTEINE,
        title: 'NAC',
        description: 'Supports relaxation and potentially eases anxiety.',
        image: nacBottle,
        url: '/products/nac',
      },
    ],
  },
  {
    key: 'energy',
    title: 'Heart & Circulatory Health',
    subtitle: 'The Power to Transform Circulation',
    leftImage: heartAndCirculatorySupport,
    products: [
      {
        productKey: productsKeyConstants.RF_RED_YEAST_RICE,
        title: 'Red Yeast Rice with CoQ10',
        description:
          'Supports optimal cholesterol levels naturally and maintains heart health.',
        image: redYeastRiceBottle,
        url: '/products/red-yeast-rice',
      },
      {
        productKey: productsKeyConstants.RF_FULL_SPECTRUM_E,
        title: 'Full Spectrum E',
        description:
          'Supports artery health and protects heart tissues from oxidative stress.',
        image: fullSpectrumBottle,
        url: '/products/full-spectrum-e',
      },
      {
        productKey: productsKeyConstants.RF_BERBERINE,
        title: 'Berberine',
        description:
          'Aids lipid metabolism, glucose control, and overall heart health.',
        image: berberineBottle,
        url: '/products/berberine',
      },
      {
        productKey: productsKeyConstants.DE_ANTIOXIDANTS,
        title: 'Antioxidants with Vitamin C & Bioflavonoids',
        description:
          'Provides antioxidants and promotes healthy blood vessels.',
        image: antioxidantsBottle,
        url: '/products/antioxidants',
      },
      {
        productKey: productsKeyConstants.RF_VESSEL_PROTECTION,
        title: 'Vessel Protection',
        description: 'Lowers homocysteine levels & supports vascular health.',
        image: vesselProtectionBottle,
        url: '/products/vessel-protection',
      },
      {
        productKey: productsKeyConstants.RF_VITAMIN_D_K2,
        title: 'Vitamin D3 and K-2 (2,000/5,000 IU)',
        description:
          'Helps prevent arterial calcification & supports heart function.',
        image: vitaminD3K22000Bottle,
        url: '/products/vitamin-d-k',
      },
    ],
  },
];
